import React from "react";

export class ImpressumNL extends React.Component {
    render() {
        return (
            <>
                <h3>Verantwoordelijke voor de website</h3>
                <p>DH Healthcare GmbH</p>

                <h3>Statutaire zetel en inschrijving</h3>
                <p>Bonn, Kantongerecht Bonn HRB 25633</p>

                <h3>Adres en contact</h3>
                <p>
                    Konrad-Zuse-Platz 1-3
                    <br />
                    53227 Bonn, Duitsland
                </p>
                <p>
                    Telefoon: +49 (0)228 / 2668 000
                    <br />
                    Fax: +49 (0) 228 / 2668 001
                    <br />
                    E-mail: healthcare.de@dedalus.com
                </p>

                <h3>Wettelijke vertegenwoordigers</h3>
                <p>
                    Dhr. Dieter Nels
                    <br />
                    Dhr. Daniel Strauch
                    <br />
                    Dhr. Winfried Post
                </p>
            </>
        );
    }
}
